module.exports = __webpack_public_path__ + "img/lg_ring_g_s_null_1.60a50d78.png";